import { domain } from 'modules/data';
import { useDispatch } from 'modules/react-redux';
import { useCallback } from 'react';

import { uploadAttachments } from '../../../../../actions';
import { AttachmentKind } from '../../../../../data/AttachmentKind';
import { NetSuiteExpenseLineExtendedExpenseReport } from '../../../data/types';
import { getFileNameWithRequestId } from '../../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const useExpenseReportFilesUploadAttachments = (
    request: domain.NetSuiteExpenseReportRequest,
    expenseLines: NetSuiteExpenseLineExtendedExpenseReport[]
) => {
    const dispatch = useDispatch();

    return useCallback(
        (files: File[], attachmentKind: AttachmentKind) => {
            const filesWithRequestUuid = files.map((file) => {
                return new File([file], getFileNameWithRequestId(file.name, request.id), {
                    type: file.type,
                    lastModified: file.lastModified,
                });
            });

            dispatch(
                uploadAttachments({
                    files: filesWithRequestUuid,
                    attachmentKind,
                    expenseLinesAttachments: expenseLines.map(({ attachment }) => attachment),
                })
            );
        },
        [dispatch, expenseLines, request.id]
    );
};
